/* Rquiere de mixin.js */

var department = {
	data () {
		return {
			listDepartments: [],
			methods: {
				create: 'department/register',
				delete: 'department/delete/',
				departmentGet: 'departments',
				update: 'department/update'
			}
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllDepartments() {
            this.$emit('showLockScreen', 'Obteniendo lista de Departamentos . . .')
			this.axiosActionIS(this.apiBackend + this.methods.departmentGet, 'GET', 'resultgetAllDepartments')
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'resultgetAllDepartments': this.resultgetAllDepartments(response); break;
				case 'resultDeleteDepartment': this.resultDeleteDepartment(response); break;
				case 'resultSaveDepartmentPOST': this.resultSaveDepartment(response, responseLocal); break;
				case 'resultSaveDepartmentPUT': this.resultSaveDepartment(response, responseLocal); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
		resultDeleteDepartment(response) {
			if(response.data.success) {
				this.deleteItemListDepartments(response.data.data)
				this.socketEmit(['DELETE_Department'], response.data.data)
				this.clearAuthDepartment()
			}
		},
		resultgetAllDepartments(response) {
			this.listDepartments = response.data.data
		},
		resultSaveDepartment(response, responseLocal) {
			console.log(response)
			if(response.data.success) {
				if(responseLocal == 'resultSaveDepartmentPOST') {
					this.addListDepartments(response.data.data)
					this.socketEmit(['NEW_Department'], response.data.data)
				} else if(responseLocal == 'resultSaveDepartmentPUT') {
					this.updateItemListDepartments(response.data.data)
					this.socketEmit(['UPDATE_Department'], response.data.data)
				}
				this.clearAuthDepartment()
				console.log('Guardado con exito')
			} else {
				this.setErrorSaveDepartmentLocal(response)
			}
		},
		setErrorSaveDepartmentLocal(response) {
			console.groupCollapsed('Error!!! Resultado de consulta axios, funcion por omision (setErrorSaveDepartmentLocal)')
			console.log(response)
			console.groupEnd()
		},
		setDepartmentOfListDepartment(index, data) {
			this.listDepartments[index].name = data.name
			this.listDepartments[index].email = data.email
		},
		updateItemListDepartments(data) {
			let index = this.listDepartments.map((el) => el.id).indexOf(data.id)
			this.setDepartmentOfListDepartment(index, data)
		}
	},
};

export default department;